import type { TypeTableColumn } from '@thefarmersfront/kitchen';

import { TextButtonCell } from '~/components/common';

import { formatNumber } from '~/utils/common';

import type { TypeReceiveReportHistoryDetail } from '~/types/receive.types';

type TypeReportDetailTask = TypeReceiveReportHistoryDetail['tasks'][number];

const countColumn = (
  accessorKey: 'sku' | 'unit' | 'taskUnit',
  header: string,
  size: number
): TypeTableColumn<TypeReportDetailTask> => ({
  accessorKey,
  header,
  size,
  cell: ({ getValue }) => {
    const value = getValue<number | null>();
    return value ? formatNumber(value) : '-';
  },
  meta: { cellStyle: { textAlign: 'right' } },
});

/**
 * [입고관리 > 입고 리포트 상세] 리포트 발행 항목 테이블
 */
const getReceiveReportDetailTasksColumnDefs = ({
  onClickViewIssueImages,
}: {
  onClickViewIssueImages: (data: TypeReportDetailTask) => void;
}) => {
  const columnDefs: TypeTableColumn<TypeReportDetailTask>[] = [
    {
      id: 'no',
      header: 'No',
      cell: ({ row }) => row.index + 1,
      size: 72,
    },
    {
      accessorKey: 'taskName',
      header: '작업 유형',
      size: 160,
    },
    {
      accessorKey: 'goodsCode',
      header: '상품코드',
      size: 200,
    },
    {
      accessorKey: 'goodsName',
      header: '상품명',
      size: 240,
    },
    {
      accessorKey: 'images',
      header: '이슈 이미지',
      size: 92,
      minSize: 92,
      cell: ({ getValue, row }) => (
        <TextButtonCell
          value={getValue<TypeReportDetailTask['images']>()}
          onClick={() => onClickViewIssueImages(row.original)}
        >
          보기
        </TextButtonCell>
      ),
    },
    countColumn('sku', '리포트 SKU', 100),
    countColumn('unit', '리포트 Unit', 100),
    countColumn('taskUnit', '부가작업처리수량', 122),
    {
      accessorKey: 'taskMeasure',
      header: '작업단위',
      size: 100,
    },
  ];

  return { columnDefs };
};

export default getReceiveReportDetailTasksColumnDefs;
